<template>
    <div class="sub-header-box">
        <div class="sub-header-left">
            <div class="sub-header-select-box">
                <el-select
                    v-if="!$selectDisabledStatus"
                    v-model="gameCode"
                    class="sub-header-select"
                    filterable
                    :disabled="$selectDisabledStatus"
                    :placeholder="$selectPlaceholder"
                    size="small"
                    @change="selectFn"
                    @visible-change="visibleChange"
                    :filter-method="filterGameList"
                >
                    <el-option
                        v-for="item in options"
                        :key="item['game_id']"
                        :label="item.name"
                        :value="item.game_code"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="sub-header-project-type" v-if="$isaccess">
                <a
                    :class="activeProjectType === 1 ? 'active' : ''"
                    @click="projectTypeFn($config.projectTypeRoute1, 1)"
                    href="javascript:void(0)"
                    >发行配置</a
                >
                <a
                    :class="activeProjectType === 2 ? 'active' : ''"
                    @click="projectTypeFn($config.projectTypeRoute2, 2)"
                    href="javascript:void(0)"
                    >业务管理</a
                >
            </div>
        </div>
        <div class="sub-header-right">
            <div
                class="sub-header-setting"
                v-if="$isaccess && $routerMaps['system']"
            >
                <el-menu
                    :default-active="activeIndex"
                    mode="horizontal"
                    @select="subMenuSelected"
                    class="el-menu-demo"
                >
                    <el-submenu
                        index="system"
                        popper-class="sub-header-setting-pop"
                    >
                        <template slot="title"
                            ><i class="el-icon-setting"></i
                        ></template>
                        <template
                            v-for="item in $routerMaps['system']['children']"
                        >
                            <el-menu-item
                                :index="`system/${item.active}`"
                                :key="item.active"
                                v-html="item.title"
                            ></el-menu-item>
                        </template>
                    </el-submenu>
                </el-menu>
            </div>
            <div class="sub-header-username">
                {{ $userInfo.name ? $userInfo.name : "游客" }}
            </div>
            <div class="sub-header-logout" @click="$helper.helper.logout()">
                <i class="el-icon-switch-button"></i>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

export default {
    name: "sub-header",
    data() {
        return {
            options: [],
            gameCode: "",
            activeProjectType: 1,
            activeIndex: "system/sdkVersion",
            showProjectTypeRoute1: true,
            showProjectTypeRoute2: true
        };
    },
    computed: {
        ...mapState([
            "$md5",
            "$base64",
            "$page",
            "$lodash",
            "$helper",
            "$route",
            "$routerMaps",
            "$gameList",
            "$activeGameCode",
            "$activeGameInfo",
            "$projectType",
            "$config",
            "$isaccess",
            "$selectDisabledStatus",
            "$selectPlaceholder",
            "$userInfo",
            "$isAdmin",
            "$isGameAdmin",
            "$gameAdminList",
            "$showProjectTypeRoute2",
            "$showProjectTypeRoute1",
            "$roles"
        ])
    },
    watch: {},
    created() {
        this.options = this.$gameList;
        this.gameCode = this.$activeGameCode;
        this.activeProjectType = this.$projectType;
        // let projectTypehide = this.$helper.cookie.get('odp-projectType-hide');
        // if(projectTypehide) {
        //     projectTypehide = parseInt(projectTypehide);
        //     if(projectTypehide === 1)  {
        //         this.showProjectTypeRoute1 = false;
        //     }
        //     if(projectTypehide === 2) {
        //         this.showProjectTypeRoute2 = false;
        //     }
        // }
    },
    methods: {
        ...mapActions(["LOADING", "SAVE_VUE_OBJECT", "LOGOUT"]),
        ...mapMutations(["updateAppGameCode", "LOADING"]),
        subMenuSelected(key, keyPath) {
            this.$route(key.toLocaleLowerCase());
        },

        /**
         * 切换发行配置和业务管理页面
         * @param path
         * @param num
         */
        projectTypeFn(path, num) {
            this.$helper.cookie.set("odp-projectType", num);
            this.$route(path);
        },

        selectFn(gamecode) {
            // this.$helper.cookie.set('odp-selectedGameCode', gamecode);
            this.$helper.cookie.remove("odp-projectType");
            this.updateAppGameCode(gamecode);
            this.LOADING(true);
            this.$route(this.$page);
        },
        visibleChange(visible) {
            if (visible) {
                this.filterGameList();
            }
        },
        filterGameList(val) {
            if (val) {
                //val存在
                let pinyin = this.$helper.pinyin.all(val);
                this.options = this.$gameList.filter(item => {
                    if (
                        item.name.indexOf(val) !== -1 ||
                        item["game_code_jianpin"].indexOf(pinyin.frist) !==
                            -1 ||
                        item["game_code_quanpin"].indexOf(pinyin.full) !== -1 ||
                        item["game_code"].indexOf(pinyin.full) !== -1
                    ) {
                        return true;
                    }
                });
            } else {
                //val为空时，还原数组
                this.options = this.$gameList;
            }
        }
    }
};
</script>

<style scoped type="scss">
.sub-header-box {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    align-items: center;
    background: #337ab7;
    /*background: rgba(50,51,50, 1);*/
    height: 60px;
    padding: 0 20px;
}

.sub-header-select {
    width: 220px;
}

.el-radio-button.is-active >>> .el-radio-button__inner {
    background: #f1f1f1;
    color: #333;
}

.sub-header-project-type {
    margin-left: 40px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;
}

.sub-header-project-type > * {
    margin: 0;
    height: 32px;
    line-height: 32px;
    background: #f4f4f4;
    padding: 0 25px;
    font-size: 14px;
    color: #606266;
}

.sub-header-project-type > *:hover {
    text-decoration: none;
}

.sub-header-project-type > *:first-child {
    border-radius: 5px 0 0 5px;
}

.sub-header-project-type > *:last-child {
    border-radius: 0 5px 5px 0;
}

.sub-header-project-type > *.active {
    background: #fff;
    font-weight: normal;
    color: #337ab7;
}

.sub-header-box .sub-header-left {
    min-width: 480px !important;
}
.sub-header-box .sub-header-left,
.sub-header-box .sub-header-right {
    flex: 1;
    width: 50%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: center;
}

.sub-header-right {
    justify-content: flex-end !important;
}

.sub-header-right > * {
    margin: 0 6px;
}

.sub-header-username {
    color: #fff;
    font-size: 14px;
    font-weight: bold;
}

.sub-header-setting,
.sub-header-logout {
    width: 25px;
    height: 25px;
    cursor: pointer;
}

.sub-header-setting i,
.sub-header-logout i {
    font-size: 25px;
    color: #fff;
    margin-right: 0;
}

.sub-header-setting:hover i,
.sub-header-logout:hover i {
    opacity: 0.8;
}

.sub-header-setting {
}
.sub-header-setting >>> .el-submenu__title {
    width: 100%;
    height: 100%;
    background: none !important;
    border: 0;
    margin: 0;
    padding: 0;
    line-height: 25px;
}
.el-menu-demo {
    width: 100%;
    height: 100%;
    background: none !important;
    border: 0;
}

.el-menu-demo li {
    width: 100%;
    height: 100%;
    background: none !important;
    margin: 0;
    padding: 0;
    border: 0;
}

.sub-header-setting >>> .el-submenu__icon-arrow {
    display: none;
}

div.el-submenu__title {
    border-bottom: 0 !important;
}
.sub-header-select >>> .el-input__inner {
    background: #337ab7;
    color: #fff;
    border: 1px solid #fff;
}

.left-menu-box >>> .el-menu-item-has-children.is-active {
    color: #337ab7 !important;
}
</style>



// WEBPACK FOOTER //
// website/subComponents/header.vue